import React from 'react';
import styled from 'styled-components';
import NavBar from './NavBar/NavBar';
import { isEmbedMode } from '../utils/embedAuth';

const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background-color: transparent;
  overflow: visible;
`;

const Content = styled.main`
  margin-left: var(--nav-width, 240px);
  padding: 2rem;
  width: 100%;
  transition: margin-left 0.3s ease;
  font-family: var(--font-body, 'Segoe UI', sans-serif);

  @media (max-width: 767px) {
    margin-left: 0;
    padding: 1.5rem;
  }
`;

const MainLayout = ({ children }) => (
  <LayoutContainer>
    {!isEmbedMode() && <NavBar />}
    <Content style={isEmbedMode() ? { marginLeft: 0 } : undefined}>{children}</Content>
  </LayoutContainer>
);

export default MainLayout;
